import { render, staticRenderFns } from "./LeadNotes.vue?vue&type=template&id=0c8cb93e&"
import script from "./LeadNotes.vue?vue&type=script&lang=js&"
export * from "./LeadNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports